import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { AdsConfigService } from '../ads-config/ads-config.service';

@Injectable({
  providedIn: 'root'
})
export class TitleService {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private adsConfigService: AdsConfigService
  ) { }

  setTitle() {
    this.titleService.setTitle(environment.title);
  }

  setIcon() {
    const iconLink = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (iconLink) {
      iconLink.href = environment.favicon;
    }
  }

  // setOgTags() {
  //   this.metaService.updateTag({ property: 'og:title', content: environment.title });
  //   this.metaService.updateTag({ property: 'og:description', content: environment.ogDescription });
  // }
  setOgTags() {
    this.metaService.updateTag({ property: 'og:title', content: environment.title });
    this.metaService.updateTag({ property: 'og:description', content: environment.ogDescription });
    this.metaService.updateTag({ property: 'og:image', content: environment.logo_dark }); // 👈 add image
    this.metaService.updateTag({ property: 'og:url', content: environment.apiUrl }); // optional, but good practice
    this.metaService.updateTag({ property: 'og:type', content: 'website' });
  }

  loadAds() {
    if (!this.adsConfigService.isEnabled()) {
      return;
    }
    if (document.querySelector('script[data-ads-script]')) {
      return;
    }
    const adsScript = document.createElement('script');
    adsScript.setAttribute('data-ads-script', 'true');
    adsScript.async = true;
    adsScript.src = this.adsConfigService.getScriptUrl();
    adsScript.crossOrigin = 'anonymous';
    document.head.appendChild(adsScript);
  }
}
